import React,{useContext,useEffect,useState}  from 'react';
import {CircularProgress, Box, Typography, Grid,Paper,Button,Step,StepLabel,Stepper, TextField, MenuItem } from "@mui/material";
import { createTheme, useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../theme/formCssStyles';
import Location from './Location';
import PrinterLocation from './PrinterLocation';
import { ThemeProvider } from '@mui/styles';
import { useHistory } from "react-router-dom";
import { errorContext } from '../Components/ErrorDisplay'
import ShellyPrinterTabs from './ShellyPrinterTabs';
import ShellyLock from './ShellyLock';
import { useAuth } from '../context/authContext';
import axios from 'axios';
import { useUrlContext } from '../context/urlContext';

const steps = [ 'Locations', 'Scanning Device', 'Shelly Lock'];

const theme = createTheme({
    palette: {
        primary: { main: '#0000ff' },
        secondary: { main: '#ff0000' }
    },
    overrides: {
    
     MuiStepIcon: {
      root: {
        '&$completed': {
          color: 'pink',
        },
        '&$active': {
          color: 'red',
        },
      },
      active: {},
      completed: {},
    },
   
  
  
    MuiStepLabel:{
        root:{
            color:'blue'
            // '&$active': {
            //     color: 'red',
            //   },  
        },
        active:{ '&$active': {
            color: 'red',
          },
        },
        },
    },    }
);
function ManageLocations( ) 
{   
    let { user } = useAuth();
    const classes = useStyles();
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
    let history = useHistory();
    const { UrlHelperObj } = useUrlContext();
    const [activeStep, setActiveStep] = useState(0);
    const [formShown,setFormShown] = useState(false);
    const [selectedRow,setSelectedRow] = useState(null);
    const [selectedRedemptionPartner,setSelectedRedemptionPartner] = useState(null);
    const [redemptionPartnerList,setRedemptionPartnerList] = useState([]);
    const [partnersLoaded,setPartnersLoaded] = useState(false);
    const [selectedLocation,setSelectedLocation] = useState(null);
    const [selectedPrinterLocation,setSelectedPrinterLocation] = useState(null);
    const [hasSelectedLocation,setHasSelectedLocation] = useState(false);
    const [mode, setMode] = useState('None');
    const {loading,setErrorMessage,handleError} = useContext(errorContext);
    // Auto-access locations can have BOTH a scanning device and a shelly lock;
    // Manual locations can only have a scanning device.
    const isAutoLocation = !!selectedLocation && (
        selectedLocation.access === 1 ||
        selectedLocation.access === '1' ||
        String(selectedLocation.access).trim().toLowerCase() === 'auto'
    );
    
    useEffect(()=>{
        setErrorMessage(null);
    },[]);

    useEffect(()=>{
        async function getRedemptionPartnerList() {
            if (!user?.issuerId) {
                setRedemptionPartnerList([]);
                setSelectedRedemptionPartner(null);
                setPartnersLoaded(false);
                return;
            }

            setPartnersLoaded(false);
            await axios.get(UrlHelperObj.rpartnerUrl_GET(user.issuerId))
                .then(response => response.data)
                .then(results => {
                    const partnerList = results || [];
                    setRedemptionPartnerList(partnerList);

                    if (partnerList.length === 1) {
                        setSelectedRedemptionPartner(partnerList[0]);
                    }
                    setPartnersLoaded(true);
                })
                .catch(err => { setPartnersLoaded(true); handleError(err); });
        }

        getRedemptionPartnerList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[user?.issuerId]);

    function handleRedemptionPartnerChange(partner) {
        setSelectedRedemptionPartner(partner);
    }

    // Hub-and-branch navigation: Locations is the home; from a selected location
    // the user opens its scanning device or (Auto only) its shelly lock.
    function goToScanningDevice() {
        setErrorMessage(null);
        if (!selectedLocation) {
            setErrorMessage("Please select a location first.");
            return;
        }
        setActiveStep(1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function goToShellyLock() {
        setErrorMessage(null);
        if (!selectedLocation) {
            setErrorMessage("Please select a location first.");
            return;
        }
        if (!isAutoLocation) {
            // Button is disabled for Manual locations; guard just in case.
            return;
        }
        setActiveStep(2);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function backToLocations() {
        setErrorMessage(null);
        setFormShown(false);
        setSelectedPrinterLocation(null);
        setSelectedRow(selectedLocation);
        setActiveStep(0);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
      React.useEffect(()=>{
        //alert("selected row:"+JSON.stringify(selectedRow))
      },[selectedRow])
      function handleSetSelectedRow(row)
      {
        setSelectedRow(row);
        switch(activeStep)
        {
            /* case 0:
                {
                    setSelectedRedemptionPartner(row);
                    break;
                } */
            case 0:
                {
                    // Only record which location is selected. Do NOT change the
                    // redemption-partner context here: the location list is fetched
                    // by that context, so changing it would refetch and empty the
                    // table (the location list must stay the club's full list).
                    setSelectedLocation(row);
                    setHasSelectedLocation(!!row);
                    break;
                }
            case 1:
                {
                    setSelectedPrinterLocation(row);
                    break;
                }
            default:
                break;
        }
            
        
      }
      function getSelectedNames()
      {
        var displayStr = "";
        if(selectedLocation !== null)
            displayStr += "Selected Location : "+selectedLocation.name;
        if(selectedPrinterLocation !== null)
        {
            const printerName = selectedPrinterLocation.name || selectedPrinterLocation.mac || selectedPrinterLocation.location_name || selectedPrinterLocation.id;
            //displayStr += " / Selected Printer Location : "+(printerName ?? "");
        }
        return displayStr;
      }
      function getStepContent(step) {
        switch (step) {
         
         /*     case 0:
                return (
             
                
                <RedemptionPartner
                setSelectedRow={handleSetSelectedRow}
                setFormShown={setFormShown}
                alreadySelectedOwnRow={selectedRedemptionPartner}
                />
                ); */
            case 0:
                return(
                    <Location
                    RedemptionPartnerRow={selectedRedemptionPartner || { id: user?.issuerId }}
                    RedemptionPartnerList={redemptionPartnerList}
                    onRedemptionPartnerChange={handleRedemptionPartnerChange}
                    setSelectedRow={handleSetSelectedRow}
                    setFormShown={setFormShown}
                    alreadySelectedOwnRow={selectedLocation}
                    mode={mode}
                    noRedemptionPartner={partnersLoaded && redemptionPartnerList.length === 0}
                    />
                );
            case 1:
                return(
                    <PrinterLocation
                     LocationRow={selectedLocation}
                     setSelectedRow={handleSetSelectedRow}
                     setFormShown={setFormShown}
                     alreadySelectedOwnRow={selectedPrinterLocation}
                            onDeleteSuccess={() => {
                                setSelectedPrinterLocation(null);
                                setSelectedRow(null);
                            }}
                     />
                    // <ShellyPrinterTabs
                    //LocationRow={selectedLocation}
                    //setSelectedRow={handleSetSelectedRow}
                    //setFormShown={setFormShown}
                    //alreadySelectedOwnRow={selectedPrinterLocation}
                    ///> 
                     
                );
            case 2:
                return(
                    <ShellyLock
                     LocationRow={selectedLocation}
                     setSelectedRow={handleSetSelectedRow}
                     setFormShown={setFormShown}
                     alreadySelectedOwnRow={null}
                    />
                );
         
            default:
                return "Unknown step";
            }
        }    
    
      
        return(
            <Box sx={{borderStyle:'none',borderColor:'green' }} style={{ paddingLeft: isMobile ? 12 : 0, paddingRight: isMobile ? 8 : 0 }}>
                            <Typography
                                variant="h5"
                                style={{color:'black', textAlign:'left', marginBottom: 12, wordBreak: 'break-word' }}
                            >
                                {activeStep === 0 ? 'Manage Locations' : activeStep === 1 ? 'Manage Scanning Devices' : 'Manage Shelly Locks'}
                            </Typography>
             {/* <Toolbar> */}
        <Grid container xs={12} direction="column">
                        <Grid item xs={12} style={{borderColor:'black',borderStyle:'none',textAlign:'left'}}>
                                    <Box style={{display:'flex',justifyContent:'flex-start',alignItems:'center',zIndex:1001}}>
                    { loading && <CircularProgress variant='indeterminate' />}
                  </Box>
                  
             </Grid>

          
            <Grid
                item
                container
                direction="row"
                xs={12}
                spacing={1}
                style={{ borderStyle: 'none', borderColor: 'blue', marginTop: isMobile ? 8 : 0 }}
            >
                <Grid item container xs={12} direction="column">
                        <Grid item container xs={12} style={{
                            borderStyle: 'none',
                            borderColor: 'green',
                            minHeight: 'auto'
                            }} direction="column" >
                                {getStepContent(activeStep)}
                        </Grid>
                </Grid>
                <Grid item xs={12} direction="row">
                    <Paper style={{ textAlign: 'left', padding: '8px 12px', wordBreak: 'break-word' }}>
                        {getSelectedNames()}
                    </Paper>
                </Grid>
                <Grid item justifyContent='flex-start' container direction="row" spacing={1}
                    style={{ display: formShown ? 'none' : '', minHeight: '40px' }}>
                    {activeStep === 0 ? (
                        <>
                            <Grid item>
                                <Button
                                type="button"
                                variant="contained"
                                disabled={!selectedLocation}
                                onClick={goToScanningDevice}
                                fullWidth={false}
                                style={{
                                    minWidth: '150px',
                                    backgroundColor: !selectedLocation ? '#bdbdbd' : 'blue',
                                    color: !selectedLocation ? '#616161' : '#ffffff',
                                    boxShadow: !selectedLocation ? 'none' : undefined,
                                    cursor: !selectedLocation ? 'not-allowed' : undefined
                                }}
                                sx={{ '&.Mui-disabled': { backgroundColor: '#bdbdbd !important', color: '#757575 !important', boxShadow: 'none' } }}
                                >
                                Scanning Device
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                type="button"
                                variant="contained"
                                disabled={!selectedLocation || !isAutoLocation}
                                onClick={goToShellyLock}
                                fullWidth={false}
                                style={{
                                    minWidth: '150px',
                                    backgroundColor: (!selectedLocation || !isAutoLocation) ? '#bdbdbd' : 'blue',
                                    color: (!selectedLocation || !isAutoLocation) ? '#616161' : '#ffffff',
                                    boxShadow: (!selectedLocation || !isAutoLocation) ? 'none' : undefined,
                                    cursor: (!selectedLocation || !isAutoLocation) ? 'not-allowed' : undefined
                                }}
                                sx={{ '&.Mui-disabled': { backgroundColor: '#bdbdbd !important', color: '#757575 !important', boxShadow: 'none' } }}
                                >
                                Shelly Lock
                                </Button>
                            </Grid>
                        </>
                    ) : (
                        <Grid item>
                            <Button
                            type="button"
                            variant="outlined"
                            onClick={backToLocations}
                            fullWidth={false}
                            style={{ minWidth: '170px' }}
                            >
                            Back to Locations
                            </Button>
                        </Grid>
                    )}
                 </Grid>
            </Grid>
        </Grid>
    </Box>
    );
}
export default ManageLocations;
